export let UserSiteDataErrorReason = /*#__PURE__*/function (UserSiteDataErrorReason) {
  UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
  UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
  UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
  return UserSiteDataErrorReason;
}({});
export class UserSiteDataError extends Error {
  constructor(reason, message) {
    super(message);
    this.name = 'UserSiteDataError';
    this.reason = reason;
  }
}